import React, { useState, useCallback, useEffect } from "react";
import { MasterTable } from "../../components/_index";
import { Box, Button } from "@mui/material";
import Grid from "@mui/material/Grid2";
import AddForms from "./AddForms";
import { useNavigate } from "react-router-dom";
import { deleteForm, getForm } from "../../services/form.service";
import SearchOutlinedIcon from "@mui/icons-material/SearchOutlined";
import { debounce } from "../../utils/debounce";
import ConfirmBox from "../../components/ConfirmBox/ConfirmBox";
import AddIcon from "@mui/icons-material/Add";
import { showToast } from "../../redux/Reducer/toastReducer";
import { useDispatch } from "react-redux";

const Form = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [data, setData] = useState([]);
  const [tableTotalCount, setTableCount] = useState(0);
  const [queryParam, setQueryParam] = useState({
    search: "",
    page: 1,
    limit: 10,
    sortType: "",
    sort: "",
  });
  console.log(queryParam, "QP");

  const GetFormData = async () => {
    try {
      const res = await getForm(queryParam);
      const modifiedData =
        res?.data.map((e) => ({
          ...e,
          // questionName: e?.questionInfo
          //   ?.map((question) => question?.questionName)
          //   .join(", "),
          questionName: e?.questionInfo.length,
        })) || [];
      setTableCount(res?.totalCount || 0);
      setData(modifiedData);
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    GetFormData();
  }, [queryParam.search, queryParam.sort, queryParam.limit, queryParam.page]);

  const columns = [
    { id: "formName", label: "Form Name" },
    { id: "questionName", label: "Question" },
    { id: "status", label: "Status" },
  ];

  const [openDrawer, setOpenDrawer] = useState(false);
  const [selectedData, setSelectedData] = useState({});

  const tableOutputEvent = useCallback((params) => {
    setQueryParam((queryParams) => ({
      ...queryParams,
      ...params,
    }));
  }, []);

  const handleAdd = () => {
    setSelectedData({});
    setOpenDrawer(true);
  };
  const handleEdit = (e) => {
    setSelectedData(e);
    const formType = e._id ? "edit" : "add";
    navigate("/addForms", {
      state: {
        selectedData: e,
        formType: formType,
      },
    });
  };

  const handleView = (e) => {
    setSelectedData(e);
  };

  const handleCloseDrawer = () => {
    setOpenDrawer(false);
  };
  const [confirmDeleteOpen, setConfirmDeleteOpen] = useState(false);
  const [selectedDataId, setSelectedDataId] = useState(null);
  const handleDelete = (e) => {
    console.log(e, "EEDD");
    setSelectedDataId(e._id);

    setConfirmDeleteOpen(true);
  };

  const deleteFunction = async () => {
    try {
      const res = await deleteForm(selectedDataId);
      setConfirmDeleteOpen(false);
      GetFormData();
      dispatch(showToast({ message: res.message, type: "success" }));
    } catch (error) {
      console.log(error);
    }
  };

  const debouncedHandleSearch = useCallback(
    debounce((searchText) => {
      setQueryParam((queryParams) => ({
        ...queryParams,
        search: searchText,
      }));
    }, 300),
    []
  );

  const handleSearch = (searchText) => {
    debouncedHandleSearch(searchText);
  };

  const [tableConfig, setTableConfig] = useState({
    isAction: true,
    isView: false,
    isEdit: true,
    isDelete: true,
    isSearch: false,
  });

  return (
    <div className="mainContent">
      <Box sx={{ height: "fit-content" }}>
        <Grid
          container
          spacing={2}
          sx={{ justifyContent: "space-between", mb: 2 }}
        >
          <Box className="SearchInputBoxContainer">
            <SearchOutlinedIcon className="Search_Icon" />
            <input
              className="SearchInputBox"
              placeholder="Search here"
              onChange={(e) => handleSearch(e.target.value)}
            />
          </Box>
          {/* <Grid size={{ xs: 12, sm: 5 }} /> */}
          {/* <Grid item xs={12} sm={2.5}>
                    <LocalizationProvider dateAdapter={AdapterDayjs}>
                      <DemoContainer components={["DatePicker", "DatePicker"]}>
                        <DatePicker openTo="year" className="datepicker w-100" />
                      </DemoContainer>
                    </LocalizationProvider>
                  </Grid> */}
          <Button onClick={() => navigate("/addForms")} className="addButton">
            <AddIcon />
            Add Form
          </Button>
        </Grid>
      </Box>

      <MasterTable
        data={data}
        columns={columns}
        tableConfig={tableConfig}
        isServerSide={true}
        handleEdit={handleEdit}
        handleDelete={handleDelete}
        // handleView={handleView}
        tableTotalCount={tableTotalCount}
        tableOutputEvent={tableOutputEvent}
      />
      {openDrawer ? (
        <AddForms
          open={openDrawer}
          handleCloseDrawer={handleCloseDrawer}
          formType={selectedData._id ? "edit" : "add"}
        />
      ) : null}

      <ConfirmBox
        open={confirmDeleteOpen}
        title="Are you sure you want to delete?"
        content={`You are about to delete this item`}
        confirmButton={"Delete"}
        setOpenConfirmBox={() => setConfirmDeleteOpen(false)}
        Function={deleteFunction}
      />
    </div>
  );
};

export default Form;
